import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'

import MarkdownWrapper from '../utils/markdown-wrapper'
// import KeyIssueTile from '../key-issues/components/key-issue-tile'
import RelatedSlider from '../layout/related-slider'
import SecondaryFooter from '../layout/secondary-footer'
import ResourceTile from '../resources/components/resource-tile'
import { Link } from 'react-router-dom'
import { routes } from '../../constants/routes'
// import ShareButtons from '../elements/share-button'

const selectKeyIssues = state => state.keyIssues
const selectRelatedKeyIssueIds = (state, chapter) => chapter?.relatedKeyIssueIds || []

const selectResources = state => state.resources
const selectRelatedResourceIds = (state, chapter) => chapter?.relatedResourceIds || []

const makeRelatedResources = createSelector(
    [selectResources, selectRelatedResourceIds],
    (resources, relatedResourceIds) => {
        return resources.filter(resource => relatedResourceIds.includes(resource.uuid))
    }
)

const makeRelatedKeyIssues = createSelector(
    [selectKeyIssues, selectRelatedKeyIssueIds],
    (keyIssues, relatedKeyIssueIds) => {
        return keyIssues.filter(issue => relatedKeyIssueIds.includes(issue.uuid))
    }
)

const mapStateToProps = (state, ownProps) => {
    let chapter = ownProps.story?.characterWrapUp
    return {
        relatedResources: makeRelatedResources(state, chapter),
        relatedKeyIssues: makeRelatedKeyIssues(state, chapter),
        keyIssueCategories: state.keyIssueCategories,
        chapter: chapter
    }
}

const CharacterWrapUp = ({ chapter, relatedResources, relatedKeyIssues, keyIssueCategories, story }) => {
    // const renderRelatedKeyIssues = () => {
    //     if (relatedKeyIssues.length === 0) {
    //         return null
    //     }
    //     let issues = relatedKeyIssues.map((issue, index) => {
    //         return <KeyIssueTile key={index} keyIssue={issue} filterObjects={keyIssueCategories} />
    //     })
    //     return (
    //         <RelatedSlider title="Interconnected Issues" classes="related-key-issues">
    //             {issues}
    //         </RelatedSlider>
    //     )
    // }

    const renderRelatedResources = () => {
        // Loop over and load related resources
        if (relatedResources.length === 0) {
            return null
        }
        let resources = relatedResources.map((resource, index) => {
            return <ResourceTile key={index} resource={resource} />
        })
        return (
            <RelatedSlider title="Real Life Solutions" classes="related-resources">
                {resources}
            </RelatedSlider>
        )
    }

    if (!chapter) {
        return null
    }
    // let murphyRoute = buildRoutePath(routes.murphysView.path, { character: story.characterSlug.substring(1) })
    // let shareText = 'Lorem Ipsum'
    return (
        <div className="character-wrap-up">
            <div className="container">
                <div className="character-wrap-up-header">
                    <div>
                        <h1>Making a Way Out of No Way</h1>
                        <MarkdownWrapper content={chapter.introduction} />
                        {/* <div className="share-wrapper">
                            <h2>Share this</h2>
                            <p>{shareText}</p>
                            <ShareButtons
                                title={story.title}
                                text={shareText}
                                url={`${window.location.origin}${murphyRoute}`}
                            />
                            <div className="share-image">
                                <img src="/sharing-01.png" alt="sharing graphic" />
                            </div>
                        </div> */}
                    </div>
                    <div>
                        <img src={chapter.primary_image?.url} alt={chapter.primary_image?.alt} />
                    </div>
                </div>
                {/* Interconnected Issues */}
                {/* <div className="container">
                    { renderRelatedKeyIssues() }
                </div> */}
                <div className="dark-bg">
                    <div className="container">
                        {/* Related Resources */}
                        { renderRelatedResources() }
                    </div>
                </div>
                <div className="character-actions">
                    <Link to={routes.murphysIndex.path} className="btn">
                        Return to Tales
                    </Link>
                </div>
                { story && story.footer &&
                    <SecondaryFooter footer={story.footer} />
                }
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(CharacterWrapUp)
